import React, { useEffect, useState } from 'react'
import { Button, Container, Form, FormControl, FormGroup, FormLabel, Row,  } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { Usuario } from '../Interfaces/Interfaces';
import { validarUsuario } from '../Promesas/Promesas';

interface Props{
  setToolbar:(isActive:boolean)=>void;
  setIsLogin: (isLogin:boolean)=>void;
  setUsuario: (usuario:Usuario)=>void;
}

const Login = (props:Props) => {
    const [usuario, setUsuario] = useState("")
    const [contrasenia, setContrasenia] = useState("")
    const [user,setUser] = useState<Usuario>()
const navigate = useNavigate()
const entrar = ()=>{
  validarUsuario(usuario,contrasenia).then((v)=>{
    if(v.length>0 && v[0].usuario==usuario && v[0].clave==contrasenia){
      props.setIsLogin(true);
      const u:Usuario = v[0]
      props.setUsuario(u)
      navigate("/dispositivos")
    }
    else{
      alert("Credenciales incorrectas")
      props.setIsLogin(false);
    }

  })


    // if(usuario==user?.nombre && contrasenia==user.clave){
    //     navigate("/dispositivos")
    // }
}
let location = useLocation();
  useEffect(()=>{
    props.setToolbar(false);
    
    
  },[])

  return (
    <Container>
        <Row>
        <Form style={{marginTop:"10%"}}>
      <FormGroup className="mb-3" controlId="usuario">
        <FormLabel>Usuario</FormLabel>
        <FormControl type="text" onChange={(e)=>{setUsuario(e.target.value)}}/>
      </FormGroup>
      <FormGroup className="mb-3" controlId="password">
        <FormLabel>Contrasena</FormLabel>
        <FormControl type="password" onChange={(e)=>{setContrasenia(e.target.value)}}/>
      </FormGroup>
      <Button onClick={entrar}>Entrar</Button>
    </Form>
        </Row>
    </Container>
  )
}

export default Login
